exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width:767px){.print-compliance-disclaimer-text{margin-right:5px;margin-left:5px}}@media (min-width:768px){.print-compliance-disclaimer-text{margin-right:50px;margin-left:50px;flex-direction:column}}.compliance-text{margin-bottom:10px;font-style:italic;font-size:smaller;overflow-wrap:break-word}", ""]);

// exports
